var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import { TabProvider } from "./Tab.context.js";
import styles from "@bookingcom/bui-core/css/Tab.module.css";
var TabControlled = function (props) {
    var activeTabId = props.activeTabId, attributes = props.attributes, className = props.className, _a = props.variant, variant = _a === void 0 ? "underlined" : _a, vertical = props.vertical, fillEqually = props.fillEqually, borderless = props.borderless, color = props.color, moreLabel = props.moreLabel, onTabChange = props.onTabChange, children = props.children;
    var rootClassName = classNames(styles.root, className, variant !== "rounded" && vertical && styles["root--vertical"], fillEqually && styles["root--equal"], borderless && styles["root--borderless"], color === "inherit" && styles["root--color-inherit"]);
    var rootRef = React.useRef(null);
    var buttonRefs = React.useRef([]);
    var navRef = React.useRef(null);
    var moreRef = React.useRef(null);
    var getButtonRef = function (el, index) {
        if (el)
            buttonRefs.current[index] = el;
    };
    var changeTab = function (id, index, options) {
        if (options === void 0) { options = {}; }
        var focus = options.focus;
        if (onTabChange)
            onTabChange(id);
        if (focus && buttonRefs.current) {
            buttonRefs.current[index].focus();
        }
    };
    return (React.createElement(TabProvider, { value: {
            variant: variant,
            activeTabId: activeTabId,
            fillEqually: fillEqually,
            moreLabel: moreLabel,
            vertical: vertical,
            rootRef: rootRef,
            navRef: navRef,
            buttonRefs: buttonRefs,
            moreRef: moreRef,
            changeTab: changeTab,
            getButtonRef: getButtonRef,
        } },
        React.createElement("nav", __assign({}, attributes, { className: rootClassName, ref: rootRef }), children)));
};
export default TabControlled;
